<template>
  <div id="cropModal" class="modal fade crop-modal" tabindex="-1" aria-labelledby="cropModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          Обрезать изображение
          <button ref="closeButton" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div v-if="newAvatar" class="d-flex justify-content-center py-4">
          <!-- Изображение для кроппера -->
          <img ref="imageElement" :src="newAvatar" alt="Image for cropping" style="max-width: 100%" />
        </div>
        <div class="modal-footer">
          <button class="grey-button" @click="closeModal">Отмена</button>
          <button class="black-button" @click="cropImage">Обрезать</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref, defineComponent, watch, nextTick } from 'vue';
  import UserService from '@/services/user';
  import { useStore } from 'vuex';
  import Cropper from 'cropperjs';
  import 'cropperjs/dist/cropper.css';
  import { Modal } from 'bootstrap';

  export default defineComponent({
    name: 'CropModal',
    components: {},
    props: {
      newAvatar: File,
    },
    setup(props) {
      const store = useStore();
      const imageElement = ref(null);
      const croppedImage = ref(null);
      let cropper = null;
      const closeButton = ref(null);

      const closeModal = () => {
        cropper.destroy();
        cropper = null;
        closeButton.value.click();
      };

      const initCropper = () => {
        if (imageElement.value) {
          cropper = new Cropper(imageElement.value, {
            aspectRatio: 1, // Соотношение сторон 1:1 для аватара
            viewMode: 1,
            autoCropArea: 1,
            responsive: true,
            scalable: true,
            zoomable: true,
            movable: true,
            guides: false, // Отключаем направляющие
            minContainerHeight: 400, // Минимальная высота контейнера
            minContainerWidth: 400,
          });
        }
      };

      const cropImage = async () => {
        if (cropper) {
          const canvas = cropper.getCroppedCanvas({
            width: 300,
            height: 300,
          });

          croppedImage.value = canvas.toDataURL('image/png'); // Для Base64
          canvas.toBlob(async (croppedBlob) => {
            const avatarFormData = new FormData();
            avatarFormData.append('avatar', croppedBlob, 'avatar.png');

            await UserService.updateAvatar(avatarFormData);
            await store.dispatch('user/me');
            closeModal();
          }, 'image/png');
        }
      };
      watch(
        () => props.newAvatar,
        (newValue) => {
          if (newValue) {
            nextTick(() => {
              initCropper(); // Инициализация cropper после рендера изображения
            });
          }
        }
      );
      return {
        croppedImage,
        imageElement,
        closeButton,
        cropImage,
        closeModal,
      };
    },
  });
</script>

<style lang="scss">
  @import '@/assets/styles/auth';

  .cropper-crop-box,
  .cropper-view-box {
    border-radius: 50%; /* Делаем рамку круглой */
  }

  .cropper-face {
    background-color: rgb(255 255 255 / 60%); /* Цвет заливки для области кропа */
  }
</style>
